import PropTypes from 'prop-types'
import styled, { css } from 'styled-components'
import IconLink from 'components/Shared/IconLink/Index'
import colors from 'components/utils/colors'

// 'order: 1' to move icon to the right of dropdown icon
const singleStyleCss = css`
  padding: 1px 0 1px 0;
  order: 1;

  &:before {
    color: ${colors.secondary40} !important;
    transform: scale(0.5);
  }

  &:hover:before {
    color: ${colors.primary40} !important;
  }
`

const multiStylesCss = css`
  padding: 2px;
  order: 1;
  border-radius: 50%;
  margin-left: 2px;

  &:before {
    color: ${colors.secondary80} !important;
  }

  &:hover:before {
    color: red !important;
  }
`

export const StyledClearIndicator = styled(IconLink)`
  ${props => props.isMulti ? multiStylesCss : singleStyleCss}
`

const ClearIndicator = (props) => {
  const { innerProps } = props
  const isMulti = props.selectProps.isMulti

  return (
    <StyledClearIndicator
      {...innerProps}
      isMulti={isMulti}
      iconName={isMulti ? 'icon-close-filters-12' : 'icon-close-12'}
    />
  )
}

ClearIndicator.propTypes = {
  innerProps: PropTypes.object,
  selectProps: PropTypes.object,
}

export default ClearIndicator
